<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label || 'Одиниці виміру'"
    :placeholder="placeholder || 'Введіть найменування'"
    :items.sync="items"
    :total-items="totalItems"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :multiple-select="multipleSelect"
    component-name="Unit"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as unitsApi from "../../backend/unitsApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Введіть найменування",
    },
    value: {
      type: [Object, Array],
    },
    placeholder: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    multipleSelect: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    totalItems: 0,
    items: [],
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await unitsApi.getUnits(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
